import { render } from "./home.vue?vue&type=template&id=4a2a34f9"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=4a2a34f9&lang=sass"
script.render = render

export default script